import { ErrorContainer } from "../../components/errors/ErrorContainer";

export default function AccessDenied() {
  return <ErrorContainer status={401} text="Zugriff verweigert" />;
}
